import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

type Props = { unassigned: number; max: number; onAssign: () => void };

/** Parent/admin-only is valid: shows open learner seats with an optional assign CTA — never a blocking gate. */
const UnassignedSeatCard = ({ unassigned, max, onAssign }: Props) => (
  <section aria-labelledby="unassigned-seat-heading" className="glass-card space-y-3 p-5">
    <div className="flex items-center gap-3">
      <UserPlus className="h-6 w-6 text-primary" aria-hidden="true" />
      <h3 id="unassigned-seat-heading" className="font-heading text-lg font-bold text-foreground">
        {unassigned} of {max} learner seat{max === 1 ? "" : "s"} unassigned
      </h3>
    </div>
    <p className="text-sm text-muted-foreground">
      Assign a seat to yourself or a child whenever you're ready. Parent access doesn't use a seat.
    </p>
    {unassigned > 0 && <Button variant="outline" onClick={onAssign}>Assign a learner seat</Button>}
  </section>
);

export default UnassignedSeatCard;
